import React from 'react';
import { prettyShortcut } from '@/hooks/useKeyboardShortcuts';

/**
 * Keyboard hint chip. Pass a combo ("mod+k", "g i", "shift+?") and it is
 * rendered for the user's platform (Ctrl+K / ⌘K).
 */
export default function Kbd({ combo, children, className = '' }) {
  const text = children ?? (combo || '').split(' ').map(prettyShortcut).join(' then ');
  return <kbd className={`is-kbd ${className}`}>{text}</kbd>;
}
